import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Row, Col, Container, Card, CardBody } from "reactstrap";
import { PaymentMethodRepository } from "../../../repositories/paymenMethod";
import "../../../assets/scss/custom/pages/_paymentform.scss";
import { useTranslation } from "react-i18next";
import PaymentMethodFormV2 from "../PaymentMethodFormV2";
import Swal from "sweetalert2";
import { PlanLayout } from "../../../layouts/PlanLayout";

import itemRow1 from "../../../assets/images/plan-item-row1.svg";
import itemRow2 from "../../../assets/images/plan-item-row2.svg";
import itemRow3 from "../../../assets/images/plan-item-row3.svg";

import { useParams } from "react-router-dom";
import "./index.css";

import p1 from "../../../assets/images/partners/bread-house.png";
import p2 from "../../../assets/images/partners/mosaico.png";
import p3 from "../../../assets/images/partners/los-antojitos.png";
import p4 from "../../../assets/images/partners/mistcity.png";
import p5 from "../../../assets/images/partners/deluxe.png";
import p6 from "../../../assets/images/partners/vaping.png";
import p7 from "../../../assets/images/partners/veteplus.png";
import p8 from "../../../assets/images/partners/avenda-uno.png";
import p9 from "../../../assets/images/partners/elgir.png";
import p10 from "../../../assets/images/partners/eureka.png";
import p11 from "../../../assets/images/partners/beauty-life.png";
import p12 from "../../../assets/images/partners/green-studio.png";
import moment from "moment";
import { getMonthName } from "../../../core/utils/dates";
import StoreSubscriptionsRepository from "../../../repositories/store_subscriptions";
import beeLogo from "../../../assets/images/LOGO@3x.png";
import { Button } from "reactstrap";
import { useIsDesktop } from "../../../helpers/useIsDesktop";
import { useScreenHeight } from "../../../helpers/useScreenHeight";
import { useScreenWidth } from "../../../helpers/useScreenWidth";
import { useSelector } from "react-redux";

const RowItem = ({ img, title, desc }) => {
  return (
    <Row className="mt-2 d-flex align-items-center">
      <Col
        xs={3}
        sm={3}
        lg="1"
        className="text-center px-1 d-flex justify-content-end"
      >
        <figure className="plan-rowitem-img">
          <img src={img} alt="" className="img-fluid" />
        </figure>
      </Col>
      <Col xs={{ size: 8 }} sm={9} lg="11">
        <div className="">
          <h6 className="plan-rowitem-title">{title}</h6>
          {desc && <p className="plan-rowitem-desc">{desc}</p>}
        </div>
      </Col>
    </Row>
  );
};

const rowItems = [
  {
    img: itemRow1,
    title: "Garantía de 30 días con prueba GRATIS",
    desc: "Tienes derecho a una prueba gratis de un mes, si por cualquier razón no estas satisfecho con bee, puedes cancelar cuando quieras y no se te hará ningún cobro"
  },
  {
    img: itemRow2,
    title: "Capacitaciones y tutoriales",
    desc: "Te incluye una capacitación 1-1 con un experto en marketing que te aconsejará a escoger los mejores premios para que tengas los mejores resultados cuanto antes"
  },
  {
    img: itemRow3,
    title: "Más de 800 negocios utilizan bee",
    desc: "Casi mil comercios como el tuyo ya están utilizando bee aumentando ventas, fidelizando a sus clientes y evitando que se vayan con la competencia"
  }
];

const partners = [p1, p2, p3, p4, p5, p6, p7, p8, p9, p10, p11, p12];

const PaymentForm = (props) => {
  const { history, subscriptioId } = props;
  const { t } = useTranslation();
  const isDesktop = useIsDesktop();
  const screenHeight = useScreenHeight();
  const screenWidth = useScreenWidth();
  const [dataPricing, setDataPricing] = useState(null);
  const { planId } = useParams();
  const [processStep, setProcessStep] = useState(0);
  const countries = useSelector(store => store.countries.countrySelected)

  const handlerPayment = async (payload) => {
    const repository = new PaymentMethodRepository();
    const response = await repository.firstPayment({
      ...payload,
      subscription_product_id: planId
    });
    if (response.status === 201) {
      Swal.fire({
        title: "",
        text: t("The payment method has been successfully updated"),
        icon: "success",
        confirmButton: true
      });
      history.push("/profile-details");
    } else {
      Swal.fire({
        title: "Error!",
        text:
          response.response.data.message ||
          "Ocurrió un error, por favor verifique que su método de pago sea válido.",
        icon: "error",
        confirmButton: true
      });
    }
  };

  const handlerPaymentSecond = async (payload) => {
    const repository = new PaymentMethodRepository();
    const response = await repository.secondPayment({
      ...payload,
      subscription_product_id: planId
    });
    if (response.status === 201) {
      Swal.fire({
        title: "",
        text: t("The payment method has been successfully updated"),
        icon: "success",
        confirmButton: true
      });
      history.push("/profile-details");
    } else {
      Swal.fire({
        title: "Error!",
        text:
          response.response.data.message ||
          "Ocurrió un error, por favor verifique que su método de pago sea válido.",
        icon: "error",
        confirmButton: true
      });
    }
  };

  const styles = isDesktop
    ? {
        maxWidth: screenWidth,
        overflowX: "hidden"
      }
    : {
        overflowX: "hidden"
      };

  const containerStyle = {
    ...styles,
    height: screenHeight,
    overflowX: "hidden"
  };
  const nextMonth = moment(new Date()).add(1, "month");
  const month = getMonthName(nextMonth.month());

  const setNextStep = () => {
    setProcessStep(processStep + 1);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const repository = new StoreSubscriptionsRepository();
        const response = await repository.getSelectedSubscription(planId);
        setDataPricing(response);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [planId]);

  const basePrice = Math.ceil(
    parseFloat(dataPricing?.base_price || "0") *
      parseInt(dataPricing?.months || "0")
  );

  return (
    <>
      {isDesktop && (
        <div fluid className="register" style={containerStyle}>
          <Row>
            <Col lg={6}>
              <Row className="justify-content-center">
                <Col lg="10" className="mt-4">
                  <PaymentMethodFormV2
                    handlerManagePayment={handlerPayment}
                    handlerManagePaymentSecond={handlerPaymentSecond}
                    paymentAmount={"0"}
                    newMembership={true}
                    pricing={dataPricing}
                    basePrice={basePrice}
                  />
                </Col>
              </Row>
            </Col>
            <Col lg={6}>
              <Row className="p-3 justify-content-center">
                <Col sm="12" lg="11">
                  <h1 className="plan-title">Inicia el mes gratis</h1>
                  <div className="px-lg-5">
                    <ul className="plan-list">
                      <li>
                        Pago {dataPricing?.name.toLowerCase()} de ${basePrice}{" "}
                        después de 1 mes de prueba
                      </li>
                      <li>
                        No se te cobrará hasta el {nextMonth.date()} {month}.{" "}
                        {nextMonth.year()}
                      </li>
                    </ul>
                  </div>
                  {rowItems.map((item, i) => (
                    <RowItem
                      title={item.title}
                      desc={item.desc}
                      img={item.img}
                      key={i}
                    />
                  ))}
                  <Row>
                    {partners.map((partner) => (
                      <Col
                        style={{
                          display: "grid",
                          alignItems: "center"
                        }}
                      >
                        <figure>
                          <img src={partner} alt="Partner" />
                        </figure>
                      </Col>
                    ))}
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      )}
      {!isDesktop && (
        <div>
          {processStep === 0 ? (
            <div
              style={{
                maxWidth: screenWidth,
                minWidth: screenWidth,
                minHeight: screenHeight
              }}
            >
              <Row>
                <Col
                  sm={{ offset: 4, size: 4 }}
                  xs={{ offset: 4, size: 4 }}
                  className="mt-1"
                >
                  <div className="mt-5 d-flex justify-content-center">
                    <img src={beeLogo} alt="" className="img-fluid" />
                  </div>
                </Col>
                <Col
                  sm={12}
                  xs={12}
                  className="mt-3 d-flex justify-content-center text-center"
                >
                  <span className="movil-title-one">
                    Inicia el <br />
                    <span className="movil-title-two">mes gratis</span>
                  </span>
                </Col>
                <div className="mt-3">
                  {rowItems.map((item, i) => (
                    <RowItem title={item.title} img={item.img} key={i} />
                  ))}
                </div>
              </Row>
              <div className="d-flex justify-content-center mt-5">
                <Button
                  onClick={() => setNextStep()}
                  className="button-continue"
                >
                  CONTINUAR
                  <i className="fa-solid fa-arrow-right text-white ms-2"></i>
                </Button>
              </div>
            </div>
          ) : (
            <div
              style={
                isDesktop
                  ? {}
                  : {
                      minHeight: screenHeight,
                      maxWidth: screenWidth,
                      backgroundColor: "#FFF"
                    }
              }
            >
              <Row>
                <Col xs={12} sm={12}>
                  <Row className="justify-content-center">
                    <Col xs="12" sm={12}>
                      <PaymentMethodFormV2
                        handlerManagePayment={handlerPayment}
                        handlerManagePaymentSecond={handlerPaymentSecond}
                        paymentAmount={"0"}
                        newMembership={true}
                        pricing={dataPricing}
                        basePrice={basePrice}
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default PaymentForm;
